// extracted by mini-css-extract-plugin
module.exports = {"participant":"ParticipantList_participant__2FgqO"};